import { render, staticRenderFns } from "./todoTasksSection.vue?vue&type=template&id=7099c0ef&scoped=true&"
import script from "./todoTasksSection.vue?vue&type=script&lang=js&"
export * from "./todoTasksSection.vue?vue&type=script&lang=js&"
import style0 from "./todoTasksSection.vue?vue&type=style&index=0&id=7099c0ef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7099c0ef",
  null
  
)

/* custom blocks */
import block0 from "./todoTasksSection.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports